export function scrollInit() {
    window.sr = ScrollReveal({
        distance: '20px',
        duration: 800,
        delay: 200,
        mobile: false,
        scale: 1
    });
    
    // Initialize all reveal animations
    sr.reveal('.c-related-content__single', 20);
    sr.reveal('.c-selected-blocks__single', 50);
    sr.reveal('.c-secondary-stats__single', 50);
    sr.reveal('.c-hero-stat');
    sr.reveal('.c-hero__content');
    sr.reveal('.c-media-block__single');
    sr.reveal('.c-quote');
    sr.reveal('.c-infographic--equals .c-infographic__tagline', {
        distance: '50px',
        duration: 750,
        easing: 'ease-out'
    });
    sr.reveal(
        '.c-infographic--equals .js-reveal',
        {
            duration: 500,
            distance: '50px',
            easing: 'ease-out',
            scale: 0.8,
            delay: 1000
        },
        500
    );
    sr.reveal('.c-infographic--x-in-y .c-infographic__tagline', {
        distance: '50px',
        duration: 750,
        easing: 'ease-out'
    });
    sr.reveal(
        '.c-infographic--x-in-y .js-reveal',
        {
            duration: 500,
            distance: '50px',
            easing: 'ease-out',
            scale: 0.8,
            delay: 500
        },
        250
    );
}